import { Theme, styled, Button } from '@material-ui/core';

const StyledButton = styled(Button)<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  border: theme.config.defaultBorder(),
  borderRadius: theme.config.defaultBorderRadius,
  position: 'relative',
  textTransform: 'none',
  width: '100%',
  display: 'block',
  textAlign: 'left',
  margin: theme.spacing(1, 0),
  padding: theme.spacing(1.5, 4, 1.5, 6),
  '&:hover': {
    backgroundColor: theme.palette.grey['50'],
    borderColor: theme.palette.primary.main,
  },
}));

export default StyledButton;
